// src/components/VerDetalleTorneo.js
import React, { useEffect, useState } from 'react'
import {
  Box,
  Grid,
  Paper,
  Typography,
  Tabs,
  Tab,
  CircularProgress
} from '@mui/material'
import { child, get, ref } from 'firebase/database'
import { databaseMiApp } from '../../services/firebase-config'

// Mappings de resultados y tipos de mesa
const resultadoMap = {
  1: '1–0',
  '-1': '0–1',
  11: '½–½',
  0: '·',
  2: '1–0 (Wk)',
  '-2': '0–1 (Wk)',
  '-11': '½–½ (Wk)',
  100: 'Bye (1.0)',
  123: 'Bye manual (1.0)',
  50: 'Bye (0.5)',
  150: 'Sin emparejar',
}

const tipoMesaMap = {
  2: 'NORMAL',
  1: 'DESCANSO',
  0: 'NO EMPAREJADO',
}

export default function VerDetalleTorneo({ torneoId }) {
  const [torneo, setTorneo] = useState(null)
  const [playersMap, setPlayersMap] = useState({})
  const [rondaSeleccionada, setRondaSeleccionada] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const recuperarTorneo = async () => {
      try {
        const dbRef = ref(databaseMiApp)
        const snapshot = await get(child(dbRef, `torneos/${torneoId}`))

        if (!snapshot.exists()) {
          setLoading(false)
          return
        }

        const datoTorneo = snapshot.val()
        const rondasValidas = Array.isArray(datoTorneo.rondas)
          ? datoTorneo.rondas.filter(Boolean)
          : []

        // Índice de la ronda actual (o 0 si no aplica)
        const actualId = datoTorneo.datosTorneos?.rondaActual
        const idxActual = rondasValidas.findIndex(r => r.idRonda === actualId)
        setRondaSeleccionada(idxActual >= 0 ? idxActual : 0)

        // Mapa de jugadores por idTorneo
        const map = {}
        if (datoTorneo.inscritos) {
          Object.values(datoTorneo.inscritos).forEach(j => {
            map[j.idTorneo] = j
          })
        }

        setPlayersMap(map)
        setTorneo(datoTorneo)
      } catch (err) {
        console.error('Error al recuperar torneo:', err)
      } finally {
        setLoading(false)
      }
    }

    recuperarTorneo()
  }, [torneoId])

  if (loading) {
    return (
      <Box p={4} textAlign="center">
        <CircularProgress />
        <Typography mt={2}>Cargando torneo…</Typography>
      </Box>
    )
  }

  if (!torneo) {
    return (
      <Box p={4}>
        <Typography variant="h6" color="error">
          No se encontró el torneo.
        </Typography>
      </Box>
    )
  }

  const rondasValidas = Array.isArray(torneo.rondas)
    ? torneo.rondas.filter(Boolean)
    : []
  const ronda = rondasValidas[rondaSeleccionada] || {}

  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom>
        {torneo.datosTorneos?.nombre || 'Torneo'}
      </Typography>

      {/* Tabs de rondas */}
      <Tabs
        value={rondaSeleccionada}
        onChange={(e, newVal) => setRondaSeleccionada(newVal)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 2 }}
      >
        {rondasValidas.map((r, idx) => (
          <Tab key={r.idRonda ?? idx} label={`Ronda ${r.idRonda}`} />
        ))}
      </Tabs>

      {/* Contenido de la ronda */}
      <Typography variant="h6" gutterBottom>
        Ronda {ronda.idRonda ?? '-'}
      </Typography>

      {/* Si no hay mesas, mostrar mensaje */}
      {!(Array.isArray(ronda.mesas) && ronda.mesas.length > 0) ? (
        <Typography color="text.secondary">
          No hay mesas para esta ronda.
        </Typography>
      ) : (
        ronda.mesas.map((mesa, idx) => {
          const white = playersMap[mesa.posIniBlancas]
          const black =
            typeof mesa.posIniNegras === 'number' && mesa.posIniNegras >= 0
              ? playersMap[mesa.posIniNegras]
              : null

          const resultadoText =
            resultadoMap[mesa.resultado] ?? mesa.resultado
          const tipoText = tipoMesaMap[mesa.tipoMesa] || ''

          return (
            <Paper key={idx} sx={{ my: 1, p: 1 }}>
  <Grid container alignItems="center">
    
    {/* Número de mesa (izquierda) */}
    <Grid item xs={1}>
      <Typography variant="body1" fontWeight="bold" color="primary">
        {idx + 1}
      </Typography>
    </Grid>

    {/* Blancas */}
    <Grid item xs={4}>
      {white ? (
        <Typography>{white.apellidos}, {white.nombres}</Typography>
      ) : (
        <Typography color="text.secondary">—</Typography>
      )}
    </Grid>

    {/* Resultado */}
    <Grid item xs={2} textAlign="center">
      <Typography variant="subtitle1">{resultadoText}</Typography>
    </Grid>

    {/* Negras o tipo */}
    <Grid item xs={4} textAlign="right">
      {mesa.tipoMesa === 2 && black ? (
        <Typography>{black.apellidos}, {black.nombres}</Typography>
      ) : (
        <Typography color="primary">{tipoText}</Typography>
      )}
    </Grid>

    {/* Número de mesa (derecha) */}
    <Grid item xs={1} textAlign="right">
      <Typography variant="body1" fontWeight="bold" color="primary">
        {idx + 1}
      </Typography>
    </Grid>

  </Grid>
</Paper>
          )
        })
      )}
    </Box>
  )
}
